export default function registerFX(Alpine) {
  // ── build lookups from server-served data ──
  const currencies = {};
  for (const c of window.APP_CURRENCIES || []) {
    currencies[c.code] = c;
  }

  const feRates = window.APP_RATES || { rates: {} };
  const rates = {};
  for (const [pair, rate] of Object.entries(feRates.rates || {})) {
    rates[pair] = Number(rate);
  }

  Alpine.store("currency", window.APP_DISPLAY_CURRENCY || "NGN");
  Alpine.store("currencies", currencies);
  Alpine.store("rates", rates);

  // ── display preference (compact vs full) — dropdown mutates this ──
  Alpine.store("display", {
    format: window.APP_DISPLAY_FORMAT || "full", // "full" | "compact"
    setFull() {
      this.format = "full";
    },
    setCompact() {
      this.format = "compact";
    },
    toggle() {
      this.format = this.format === "full" ? "compact" : "full";
    },
  });

  // ── shared number formatter — reads display store, so reactive ──
  function fmtNumber(n) {
    if (Alpine.store("display").format === "compact") {
      return new Intl.NumberFormat(undefined, {
        notation: "compact",
        maximumFractionDigits: 1,
      }).format(n);
    }
    return n.toLocaleString();
  }

  // ── $convertMoney(amount, from, to) ──
  // same currency → canonical "₦45,000,000" (no ~)
  // cross currency → approximate "~$28,125"
  // no rate       → "" (caller shows original only)
  Alpine.magic("convertMoney", () => (amount, from, to) => {
    const sym = (currencies[to] || {}).symbol || "";
    if (from === to) {
      return `${sym}${fmtNumber(amount)}`;
    }
    const rate = rates[`${from}_${to}`];
    if (rate === undefined) return "";
    return `~${sym}${fmtNumber(amount * rate)}`;
  });

  // ── $fmtCount(n) — views, beds, etc. same format pref, no currency ──
  Alpine.magic("fmtCount", () => (n) => fmtNumber(n));
}
